
import { Inject, mixins, Options } from "vue-property-decorator";
import {
  htmlSerializer,
  ArrowRight,
  GetUserMixin,
  htmlToObject,
  parseHtmlString,
  Renderer,
  timingFilter,
} from "@rtl/ui";
import { ContentPageFetcher, VoteItemFetcher } from "@/mixins";
import {
  Container,
  CtaButton,
  Headline,
  Page,
  RtlNav,
  Separator,
  TextContent,
} from "@/views/components";

@Options({
  components: {
    ArrowRight,
    Container,
    CtaButton,
    Headline,
    Page,
    Renderer,
    RtlNav,
    Separator,
    TextContent,
  },
})
export default class VoteIndexPage extends mixins(
  ContentPageFetcher,
  GetUserMixin,
  VoteItemFetcher
) {
  @Inject()
  rtlUrl!: string;

  get contentHtml() {
    const skeleton = this.contentPage?.html
      ? htmlToObject(parseHtmlString(this.contentPage.html))
      : undefined;

    const element = timingFilter(
      skeleton?.filter((element) => {
        return (
          typeof element === "string" || element.componentName !== "banner"
        );
      }) ?? []
    )[0];

    return element ? htmlSerializer([element], false) : "";
  }
}
